const DATA_SHEETS = "/datasheets"

export const LINKS = {
    HOME: "/index.html",
    ABOUT: "/about",
    MODDED_WEAPON_BUILDER: "/moddedweaponbuilder",
    DAMAGE_SIMULATOR: "/armordamagecalculator",
    DATA_SHEETS: "/datasheets",
    DATA_SHEETS_WEAPONS: `${DATA_SHEETS}/weapons`,
    DATA_SHEETS_AMMO: `${DATA_SHEETS}/ammo`,
    DATA_SHEETS_PLATES_INSERTS: `${DATA_SHEETS}/plates_inserts`,
    DATA_SHEETS_HELMETS: `${DATA_SHEETS}/helmets`,
    DATA_SHEETS_ARMOR: `${DATA_SHEETS}/armor`,
    DATA_SHEETS_ARMOR_MODULES: `${DATA_SHEETS}/armor_modules`,
    ARMOR_VS_AMMO: `${DATA_SHEETS}/armor_vs_ammo`,
    AMMO_VS_ARMOR: `${DATA_SHEETS}/ammo_vs_armor`,
    AMMO_EFFECTIVENESS_CHART: `${DATA_SHEETS}/ammo_effectiveness`,

    BALLISTICS_SIMULATOR: `/ballistics_simulator`,
    BALLISTIC_CALCULATOR: `/ballistic_calculator`,

    TEST_PAGE: `/test_page`
}